import ClosingCard from './closingCard'

export { ClosingCard }
